module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"retry":"재시도","upload_failed":"업로드 실패","ai_clothing_detected":"AI 착용샷","ai_analyzing":"AI 분석중"}}')
  delete Component.options._Ctor
}
